import { render, staticRenderFns } from "./share_box2.vue?vue&type=template&id=2f724735&scoped=true&"
import script from "./share_box2.vue?vue&type=script&lang=js&"
export * from "./share_box2.vue?vue&type=script&lang=js&"
import style0 from "./share_box2.vue?vue&type=style&index=0&id=2f724735&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f724735",
  null
  
)

export default component.exports